<itl-alberta-icon class="icon" [name]="icon"></itl-alberta-icon>

  